module.exports = __webpack_public_path__ + "static/comingsoon-8e9f5284a7ad80dd6ce534d9e6cac793.mp4";